import { render, staticRenderFns } from "./NotifyWishlistModal.vue?vue&type=template&id=652f232c&scoped=true"
import script from "./NotifyWishlistModal.vue?vue&type=script&lang=js"
export * from "./NotifyWishlistModal.vue?vue&type=script&lang=js"
import style0 from "./NotifyWishlistModal.vue?vue&type=style&index=0&id=652f232c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f232c",
  null
  
)

export default component.exports